// extracted by mini-css-extract-plugin
export default {"root":"_2jPGh","cover":"YpNhf","middle":"TP8VS","mature-block":"_2cuPa","matureBlock":"_2cuPa","underlay":"_3b-i8"};